<template>
  <v-container
    id="export-report"
  >
    <v-row>
      <v-col>
        <app-city-combobox
          :filter="payload"
        ></app-city-combobox>
      </v-col>
      <v-col>
        <v-text-field
          v-model="payload.inicioString"
          v-mask="'##/##/####'"
          label="Data Inicial"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="payload.finalString"
          v-mask="'##/##/####'"
          label="Data Final"
        ></v-text-field>
      </v-col>
      <v-col>
        <app-consultant-combobox
          :filter="payload"
        ></app-consultant-combobox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AppConsultantCombobox } from '@/modules/user'
import { AppCityCombobox } from '@/modules/city'

export default {
  components: {
    AppConsultantCombobox,
    AppCityCombobox
  },
  data () {
    return {
      payload: {}
    }
  }
}
</script>
